import { inject, Injectable } from '@angular/core';
import { EventLoggerService } from '@infodocs/shared/modules/event-logging/event-logger-service';
import { UserpilotService } from '@infodocs/shared/services/userpilot.service';

@Injectable({
	providedIn: 'root'
})
export class UserPilotEventLoggerServiceService implements EventLoggerService {
	private readonly userPilotService = inject(UserpilotService);

	public logEvent(message: string, payload?: Record<any, any>) {
		return this.userPilotService.track(message, payload ?? {});
	};
}
